import React from 'react';
// import ReactDOM from 'react-dom';
import ReactDOM from "react-dom/client";
import App from './App';
import "./styles/index.css";
import './styles/App.css';
import Feed from './components/Feed';


// ReactDOM.render(
//     <h1>Hello</h1>,
//         document.getElementById('root')
//     );





// ReactDOM.render(
//     <App />,
//     document.getElementById('root')
// ); 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);